// extracted by mini-css-extract-plugin
module.exports = {"card":"_1IC6x","summary-type":"_2PwRt","sanpshot":"_1p6RE","question-type":"_3WxNX"};